module.exports = __webpack_public_path__ + "img/search-discover-selected.b2f3aaa7.svg";